import { useContext } from "react";
import { AmityAuthContext } from "@/providers/AmityAuthProvider";

export const useAmityAuth = () => {
  const context = useContext(AmityAuthContext);
  if (context === undefined) {
    throw new Error("useAmityAuth must be used within a AmityAuthProvider");
  }
  return context;
};
